// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OHlR","colMin":"styles_colMin__3IPML"};